import config from "./../config";
import axios from 'axios';
import{ message } from "antd";

const server = config.server;

const HTTP_GET = async (url, params, navigate=undefined) => {
    try {
        const token = localStorage.getItem('token') || null;
        const response = await axios.get(`${server}${url}${params ? '/' + params: ''}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });

        return response.data;

    } catch (e) {
        handleLogout(e, navigate);
    }
}

const HTTP_POST = async (url, params, navigate=undefined) => {
    try {
        const token = localStorage.getItem('token') || null;
        const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
        const response = await axios.post(`${server}${url}`, params, { headers: headers });

        return response;

    } catch (e) {
        handleLogout(e, navigate);
    }
}

const HTTP_PUT = async (url, params, navigate=undefined) => {
    try {
        const token = localStorage.getItem('token') || null;
        const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
        const response = await axios.put(`${server}${url}`, params, { headers: headers });

        return response;

    } catch (e) {
        handleLogout(e, navigate);
    }
}

const HTTP_DELETE = async (url, params, navigate=undefined) => {
    try {
        const token = localStorage.getItem('token') || null;
        const headers = { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
        const response = await axios.delete(`${server}${url}`, params, { headers: headers });

        return response;

    } catch (e) {
        handleLogout(e, navigate);
    }
}

function handleLogout (e, navigate) {

    if (e.response?.status === 401) {
        message.error("Tu sesión ha expirado.");
        if (navigate) navigate("/");
    } else if (e.response?.status === 500) {
        message.error(e.response.data.msg || "Error del servidor.");
    }
};

export default {
    HTTP_GET,
    HTTP_POST,
    HTTP_PUT,
    HTTP_DELETE
};